import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface LeverageFieldProps {}

export const LeverageField: React.FC<LeverageFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ leverage: number }>()

  return (
    <FormField
      name="leverage"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Leverage</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              {...register('leverage')}
              placeholder={'Enter the leverage...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
